import { memo, useCallback, useContext, useMemo } from "react"
import UserContext from "../../contexts/UserContext/context"
import Input from "../Input"
import { useTranslation } from "react-i18next"
import Icon from "../Icon"
import { ICON } from "../Icon/data"
import './index.scss'

export type FleetSelectValue = {
  value?: number
  name?: string
}

type FleetSelect = {
  onInput: (val: FleetSelectValue) => FleetSelectValue
  value?: number
  size?: 'l' | 'm' | 's'
}

const FleetSelect = memo(({ onInput, value, size }: FleetSelect) => {
  const { t } = useTranslation()

  const { user } = useContext(UserContext)

  const fleetLookup = useMemo(() => {
    const lookup: Record<number, string> = {}
    if (user.available_fleets.length) {
      user.available_fleets.forEach((f) => {
        lookup[f.fleetid] = f.name
      })
    }
    return lookup
  }, [user.available_fleets])

  const onChange = useCallback((value: number) => {
    onInput({ value, name: fleetLookup[value] })
  }, [onInput, fleetLookup])

  const buttonLabel = useMemo(() => (
    <div className="FleetSelect__label">
      {t('Change fleet')}
      <Icon icon={ICON.CARS} />
    </div>
  ), [t])

  return (
    <div className="FleetSelect">
      <Input
        size={size}
        type="buttonselect"
        label={buttonLabel}
        value={value}
        onInput={onChange}
        options={fleetLookup}
      />
    </div>
  )
})

export default FleetSelect
